// extracted by mini-css-extract-plugin
export default {"formBox":"Auth_formBox__OPWaZ","form-control":"Auth_form-control__Pz469","divider":"Auth_divider__QGRmx"};